import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/")({
  beforeLoad: ({ context }) => {
    if (!context.me.activeOrg && context.me.user.platformRole === "admin")
      throw redirect({ to: "/admin" });
    throw redirect({ to: "/projects" });
  },
});
